import React from "react";
import "./AboutMe.css";
// Import local images
import AboutNav from "../assets/AboutNav.jpg";
import AboutMeImage from "../assets/AboutMe.jpg";

const AboutMe = () => {
  // Remove the useEffect and state management for Firebase
  // Directly use imported images

  return (
    <div className="about-me">
      {/* Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url(${AboutNav})`,
        }}
      >
        <div className="hero-content">
          <h1>About Me</h1>
          <p className="hero-subtitle">Capturing Life's Beautiful Moments</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-container">
        <div className="about-content">
          {/* Profile Section */}
          <div className="profile-section">
            <div className="profile-image">
              <img src={AboutMeImage} alt="Profile" className="profile-photo" />
            </div>

            <div className="profile-info">
              <h2>Hello, I'm Dilan Munasingha</h2>

              <p className="intro-text">
                Driven by passion and shaped by experience, I bring 5 years of
                professional expertise and academic grounding as an Image Arts
                Undergraduate (UOK) into every project I create. At Dilan
                Munasingha Photography, my vision is simple: To craft powerful
                visuals that reflect beauty, style, and authenticity. I offer a
                blend of creativity, precision, and storytelling across fashion,
                portraits, and events delivering refined, high-quality images
                that stand apart. Your story is unique, and my lens is dedicated
                to capturing it with clarity, elegance, and
                unforgettable artistry.
              </p>

              <div className="stats-grid">
                <div className="stat-item">
                  <h3>500+</h3>
                  <p>Projects Completed</p>
                </div>
                <div className="stat-item">
                  <h3>5+</h3>
                  <p>Years Experience</p>
                </div>
                <div className="stat-item">
                  <h3>1000+</h3>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
          </div>

          {/* My Story Section */}
          <section className="story-section">
            <h2>My Story</h2>
            <div className="story-content">
              <p>
                My journey in photography began when I first picked up a camera
                during a family trip. The ability to freeze moments in time and
                preserve memories fascinated me. Since then, I've dedicated
                myself to mastering the art of capturing light, emotion, and
                beauty in every frame.
              </p>
              <p>
                I believe that every photograph tells a story, and my mission is
                to create images that evoke emotion and preserve precious
                memories for generations to come.
              </p>
            </div>
          </section>

          {/* Specialties Section */}
          <section className="specialties-section">
            <h2>My Specialties</h2>
            <div className="specialties-grid">
              <div className="specialty-card">
                <div className="specialty-icon">📷</div>
                <h3>Portrait Photography</h3>
                <p>
                  Capturing the unique personality and essence of individuals
                </p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">🌄</div>
                <h3>Landscape Photography</h3>
                <p>Showcasing the breathtaking beauty of nature</p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">💒</div>
                <h3>Wedding Photography</h3>
                <p>Documenting love stories and special moments</p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">🏢</div>
                <h3>Commercial Photography</h3>
                <p>Professional images for businesses and brands</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
